import { workspacesTypes, baseTypes } from '../types';
import {
  TAddWorkspaceAccessAction,
  TAddWorkspaceAccessPayload,
  TAddWorkspaceAction,
  TAddWorkspacePayload,
  TDeleteWorkspaceAccessAction,
  TDeleteWorkspaceAccessPayload,
  TDeleteWorkspaceAction,
  TDeleteWorkspacePayload,
  TEditWorkspaceAccessAction,
  TEditWorkspaceAccessPayload,
  TEditWorkspaceAction,
  TEditWorkspacePayload,
  TGetCompanyWorkspacesAction,
  TGetUserWorkspacesAction,
  TGetWorkspaceAccessesPayload,
  TGetWorkspacesAccessesAction,
  TPutCompanyWorkspacesAction,
  TPutCompanyWorkspacesPayload,
  TPutUserWorkspacesAction,
  TPutUserWorkspacesPayload,
  TPutWorkspaceAccessesAction,
  TPutWorkspaceAccessesPayload,
  TSetSelectedWorkspaceAction,
  TSetSelectedWorkspacePayload
} from 'src/interfaces/workspacesReduxShapes';

export const getCompanyWorkspaces = (
  payload?: TGetCompanyWorkspacesAction['payload']
): TGetCompanyWorkspacesAction => ({
  type: workspacesTypes.GET_COMPANY_WORKSPACES,
  payload
});

export const putCompanyWorkspaces = (payload: TPutCompanyWorkspacesPayload): TPutCompanyWorkspacesAction => ({
  type: workspacesTypes.PUT_COMPANY_WORKSPACES,
  payload
});

export const getUserWorkspaces = (payload?: TGetUserWorkspacesAction['payload']): TGetUserWorkspacesAction => ({
  type: workspacesTypes.GET_USER_WORKSPACES,
  payload
});

export const putUserWorkspaces = (payload: TPutUserWorkspacesPayload): TPutUserWorkspacesAction => ({
  type: workspacesTypes.PUT_USER_WORKSPACES,
  payload
});

export const addWorkspace = (payload: TAddWorkspacePayload): TAddWorkspaceAction => ({
  type: workspacesTypes.ADD_COMPANY_WORKSPACE,
  payload
});

export const editWorkspace = (payload: TEditWorkspacePayload): TEditWorkspaceAction => ({
  type: workspacesTypes.EDIT_COMPANY_WORKSPACE,
  payload
});

export const deleteWorkspace = (payload: TDeleteWorkspacePayload): TDeleteWorkspaceAction => ({
  type: workspacesTypes.DELETE_COMPANY_WORKSPACE,
  payload
});

export const setSelectedWorkspace = (payload: TSetSelectedWorkspacePayload): TSetSelectedWorkspaceAction => ({
  type: workspacesTypes.SET_SELECTED_WORKSPACE,
  payload
});

export const resetPreselectedAllocationOnWorkspaceChange = (): { type: string; payload: { id: null } } => ({
  type: baseTypes.SET_PRESELECTED_ALLOCATION_ID,
  payload: { id: null }
});

export const getWorkspaceAccesses = (payload: TGetWorkspaceAccessesPayload): TGetWorkspacesAccessesAction => ({
  type: workspacesTypes.GET_COMPANY_WORKSPACES_ACCESS,
  payload
});

export const putWorkspaceAccesses = (payload: TPutWorkspaceAccessesPayload): TPutWorkspaceAccessesAction => ({
  type: workspacesTypes.PUT_COMPANY_WORKSPACES_ACCESS,
  payload
});

export const addWorkspaceAccess = (payload: TAddWorkspaceAccessPayload): TAddWorkspaceAccessAction => ({
  type: workspacesTypes.ADD_COMPANY_WORKSPACE_ACCESS,
  payload
});

export const editWorkspaceAccess = (payload: TEditWorkspaceAccessPayload): TEditWorkspaceAccessAction => ({
  type: workspacesTypes.EDIT_COMPANY_WORKSPACE_ACCESS,
  payload
});

export const deleteWorkspaceAccess = (payload: TDeleteWorkspaceAccessPayload): TDeleteWorkspaceAccessAction => ({
  type: workspacesTypes.DELETE_COMPANY_WORKSPACE_ACCESS,
  payload
});
